import React from "react";
import { Checkbox } from "antd";
import "./CustomCheckbox.css";

const CustomCheckbox = React.forwardRef((props, ref) => {

    const {variant = '', className = '', ...rest} = props;

    const variantClass = variant === 'light' ? 'custom-checkbox-light' : 'custom-checkbox-dark';

    return (
        <span ref={ref} className="custom-checkbox-wrapper">
            <Checkbox
                {...rest}
                className={`custom-checkbox ${variantClass} ${className}`}
            />
        </span>
    )
});

CustomCheckbox.displayName = 'CustomCheckbox';

export default CustomCheckbox;
